module.exports = "/img/_/_/_/assets/images/icon//epic.png?d19eee2de5d6bb6d7502fff47f55fafc";